import { useTranslation } from "react-i18next";
import styles from "./PartnerShip.module.scss";

const PartnerShip = () => {
  const { t } = useTranslation("translation");

  const getTranslatedArray = (key: string): string[] => {
    const result = t(key, { returnObjects: true });
    return Array.isArray(result) ? (result as string[]) : [];
  };

  const getTranslatedTableRows = (
    key: string,
  ): Array<{ type: string; description: string; example: string }> => {
    const result = t(key, { returnObjects: true });
    return Array.isArray(result)
      ? (result as Array<{
          type: string;
          description: string;
          example: string;
        }>)
      : [];
  };

  const getTranslatedTableHeaders = (key: string): string[] => {
    const result = t(key, { returnObjects: true });
    return Array.isArray(result) ? (result as string[]) : [];
  };

  return (
    <div className="container">
      <div className={styles.partnership_container}>
        <div className={styles.partnership_header}>
          <h1 className={styles.partnership_title}>
            {t("partnership_page.title")}
          </h1>
        </div>

        <div className={styles.partnership_section}>
          <div className={styles.section_number}>1</div>
          <h2 className={styles.section_titles}>
            {t("partnership_page.philosophy.title")}
          </h2>
          <div className={styles.section_content}>
            {getTranslatedArray("partnership_page.philosophy.content").map(
              (paragraph: string, index: number) => (
                <p key={index}>{paragraph}</p>
              ),
            )}
          </div>
        </div>

        <div className={styles.partnership_section}>
          <div className={styles.section_number}>2</div>
          <h2 className={styles.section_titles}>
            {t("partnership_page.who_can_partner.title")}
          </h2>
          <div className={styles.section_content}>
            <p>{t("partnership_page.who_can_partner.content")}</p>
            <ul className={styles.partnership_list}>
              {getTranslatedArray("partnership_page.who_can_partner.list").map(
                (item: string, index: number) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ),
              )}
            </ul>
          </div>
        </div>

        <div className={styles.partnership_section}>
          <div className={styles.section_number}>3</div>
          <h2 className={styles.section_titles}>
            {t("partnership_page.benefits.title")}
          </h2>
          <div className={styles.section_content}>
            <ul className={styles.partnership_list}>
              {getTranslatedArray("partnership_page.benefits.list").map(
                (item: string, index: number) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ),
              )}
            </ul>
          </div>
        </div>

        <div className={styles.partnership_section}>
          <div className={styles.section_number}>4</div>
          <h2 className={styles.section_titles}>
            {t("partnership_page.types.title")}
          </h2>
          <div className={styles.section_content}>
            <table className={styles.partnership_table}>
              <thead>
                <tr>
                  {getTranslatedTableHeaders(
                    "partnership_page.types.table.headers",
                  ).map((header: string, index: number) => (
                    <th key={index}>{header}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {getTranslatedTableRows(
                  "partnership_page.types.table.rows",
                ).map((row, index: number) => (
                  <tr key={index}>
                    <td>{row.type}</td>
                    <td>{row.description}</td>
                    <td>{row.example}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className={styles.partnership_section}>
          <div className={styles.section_number}>5</div>
          <h2 className={styles.section_titles}>
            {t("partnership_page.how_it_works.title")}
          </h2>
          <div className={styles.section_content}>
            <ol className={styles.ordered_list}>
              {getTranslatedArray("partnership_page.how_it_works.list").map(
                (item: string, index: number) => (
                  <li key={index} dangerouslySetInnerHTML={{ __html: item }} />
                ),
              )}
            </ol>
          </div>
        </div>

        <div className={styles.partnership_section}>
          <div className={styles.section_number}>6</div>
          <h2 className={styles.section_titles}>
            {t("partnership_page.why_partner.title")}
          </h2>
          <div className={styles.section_content}>
            <div className={styles.highlight_box}>
              {getTranslatedArray("partnership_page.why_partner.content").map(
                (paragraph: string, index: number) => (
                  <p key={index}>{paragraph}</p>
                ),
              )}
            </div>
          </div>
        </div>

        <div className={styles.cta_section}>
          <div className={styles.section_number}>7</div>
          <p className={styles.cta_text}>{t("partnership_page.cta.text")}</p>
          <a
            href={"https://store.luxmart.site/"}
            target="_blank"
            rel="noreferrer"
            className={styles.cta_button}
          >
            {t("partnership_page.cta.button")}
          </a>
        </div>
      </div>
    </div>
  );
};

export default PartnerShip;
